import { msg } from '~/utils/validation';
import { z } from 'zod';

export type Schema = z.infer<typeof schema>;

export const schema = z.object({
  group: z.string({ message: msg.required }).transform(s => Number(s)),
  competition_type: z.string({ message: msg.required }),
  age_category: z.string({ message: msg.required }).transform(s => Number(s)),
  body_weight: z.number({ message: msg.required }).multipleOf(0.01),
  squat: z.number({ message: msg.required }).multipleOf(0.05),
  benchpress: z.number({ message: msg.required }).multipleOf(0.05),
  deadlift: z.number({ message: msg.required }).multipleOf(0.05),
  lot: z
    .literal('')
    .transform(() => undefined)
    .or(z.coerce.number())
    .optional(),
  rank: z
    .literal('')
    .transform(() => undefined)
    .or(z.coerce.number())
    .optional(),
  is_coef_group: z.boolean(),
  disqualified: z.boolean(),
  good_lifts: z.number().optional(),
  good_lifts_bp: z.number().optional(),
  // Native <select> writes strings into form state ('' when the placeholder is selected, '42' when a team is picked).
  // z.number().optional() rejects strings and z.coerce.number() turns '' into 0 — both wrong.
  // Cleaner alternative: setValueAs in register() and keep the schema as z.number().nullable().optional().
  team: z.unknown().transform((v): number | null => {
    if (v === '' || v === null || v === undefined) return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
  }),
});
